module.exports = __webpack_public_path__ + "img/country_selector_logo.4dc9fa74.svg";